export default {"src":"/_next/static/media/upload-icon.e7edba2c.svg","height":513,"width":513};